import { HorizontalBasicBar } from '../../../Charts/Bar/Horizontal';

import { Box, Skeleton } from '@chakra-ui/react';
import PanelCard from '../../../PanelCard';
import {
  useGetAnalyticsCountByAssignee,
  useGetAnalyticsCountByAssigneeExport,
} from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import Empty from 'views/main/organization/analytics-v3/icons/empty';
import Error from 'views/main/organization/analytics-v3/components/Error';
import { AxiosError } from 'axios';

export default function IncidentCountByAssignee({
  isOrgAnalytics = false,
}: {
  isOrgAnalytics?: boolean;
}) {
  const {
    data,
    isLoading,
    isError,
    refetch: refetchCountByAssignee,
    error,
  } = useGetAnalyticsCountByAssignee();
  const { isLoading: isLoadingCountByAssignee, refetch: refetchCountByAssigneeExport } =
    useGetAnalyticsCountByAssigneeExport();

  const isEmpty = data?.length === 0;

  const handleExport = () => {
    refetchCountByAssigneeExport();
  };
  return (
    <PanelCard
      title="Incident Count by Assignee"
      onExportClick={handleExport}
      chartDescription="Top 10 Assignees"
    >
      <Box position="relative" height={616}>
        {isLoading ? (
          <Skeleton height={616} />
        ) : isError ? (
          <Error
            onRefreshClick={refetchCountByAssignee}
            errorMessage={(error as AxiosError).response?.data?.message}
          />
        ) : isEmpty ? (
          <Empty />
        ) : (
          <HorizontalBasicBar
            data={data || []}
            isOrgAnalytics={isOrgAnalytics}
            chartTitle="Incident Count by Assignee"
          />
        )}
      </Box>
    </PanelCard>
  );
}
